/**
 * 门户管理端-企业应用-网站微信支付APIv3
 */
import request from "@/utils/request";

/**
 * 用户取消订单
 */
export function closeOrder(orderId) {
  return request({
    url: "/api/v1/portalmanage/wx-pay/cancel/" + orderId,
    method: "post",
  });
}

/**
 * 支付通知
 */
export function tradeNotify(data) {
  return request({
    url: "/api/v1/portalmanage/wx-pay/native/notify",
    method: "post",
    data,
  });
}

/**
 * 调用统一下单API，生成支付二维码
 */
export function wxPay(goodsId) {
  return request({
    url: "/api/v1/portalmanage/wx-pay/native/" + goodsId,
    method: "post",
  });
}

/**
 * 查询订单：测试订单状态用
 */
export function getOrderStatus(orderId) {
  return request({
    url: "/api/v1/portalmanage/wx-pay/query/" + orderId,
    method: "get",
  });
}

export default {
  closeOrder,
  tradeNotify,
  wxPay,
  getOrderStatus,
};
